import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../actions/project';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {ToBeCharts} from '../components';
import {Insights} from '../components'
import {ButtonDeleteChart} from '../components'
import {ToBeStrategyMapEd} from '../components/edComponents';
import {ToBeStrategyMapEdEnglish} from '../components/edComponents';
import {EdModal} from '../components/edComponents';
import {ChangeChartTitle} from '../components'
import CircularProgress from '@material-ui/core/CircularProgress';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';


const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    buttonColumn: {
      display: 'inline-block',
      textAlign: 'center',
      cursor: 'pointer',
    },
    lineButton: {
      'justify-content': 'space-between',
      display: 'flex',
      width: '1120px',
      marginLeft: '4.8%',
      transform: 'translateY(-54px)',
      'z-index': '100'

    },
    ButtonContener: {
      'align-items': 'center',
      display: 'inline',
      width: '100%'

    },
    buttonRow: {
      width: '100%',
      backgroundColor: theme.palette.background.paper,
    },
    deleteRow: {
      'justify-content': 'space-between',
      display: 'flex',
      width: '300px'
    },
    seriesButton: {
      backgroundColor: theme.palette.background.paper,
      width: '120%',
      textTransform: 'none'
    },
    h1: {
      display: 'inline'
    },
    head: {
      display: 'flex',
    },
    ButtonImport: {
      marginBottom: '20px',

    }

}));

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  padding: grid * 2,
  margin: `0 ${grid-6}px 0 0`,
  // minHeight: '100px',
  // overflow: 'hidden',
  width: '100%',

  // change background colour if dragging
  background: isDragging ? 'lightgreen' : '#ececec',

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? '#e1f5fe' : 'none',
  display: 'flex',
  padding: grid,
  justifyContent: 'space-between',
  width: '1120px',
  // transform: 'translateY(-30px)',
  overflow: 'hidden',
  textAlign: 'center'
});
const reorder = (list, startIndex, endIndex, NewDroppableId) => {
    const result = Array.from(list);
    // // console.log(result, 'result', startIndex, endIndex, NewDroppableId)
    // result[startIndex]['type'] = NewDroppableId
    const [removed] = result.splice(startIndex, 1);
    // // console.log(removed, 'removed')
    result.splice(endIndex, 0, removed);

    return result;
};





function ToBeStrategyMapDetail({getAllStrategyMap, strategyMapList, updateChart, selected, getDetailChart, match: {params: {projectId, chartId}}}) {
    const [openImport, setOpenImport] = React.useState(false);
    const [openUpdateColumn, setOpenUpdateColumn] = React.useState(false);
    const [openUpdateRow, setOpenUpdateRow] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(false);
    const [values, setValues] = React.useState({
        title: '',
        titleCompany: ''
    });
    const [columnKey, setColumnKey] = React.useState({
        key: 0,
    });
    const [rowKey, setRowKey] = React.useState({
        key: 0,
    });

    const classes = useStyles();

    const colorButton = {
      0: '#ec407a',
      1: '#7e57c2',
      2: '#4caf50',
      3: '#ffeb3b',
      4: '#03a9f4',
      5: '#1c7ff4',
    }


    // const changeColor = (key, i) => {
    //   colorButton[i] = colorButton[key]
    //   colorButton[key] = colorButton[i]
    //   console.log(colorButton, 'changeColor')
    // }
    //
    // const color = []
    // Object.values(colorButton).forEach((item, i) => {
    //     console.log('color', item)
    //   color.push(item)
    // });
    // // console.log('colors', color)





    React.useEffect(() => {
        getDetailChart(projectId, chartId)
        getAllStrategyMap(projectId)
    }, [projectId, chartId]);

    if (!selected) {
        return (
            <div
              style={{
                width: '1000px',
                height: '700px',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex'
              }}>
                <CircularProgress
                  style={{
                      alignItems: 'center',
                      justifyContent: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                    }}/>
            </div>
        )
    }

    const handleChange = name => event => {
        setValues({...values, [name]: event.target.value});
    };

    const clickColumnUpdate = (key) => {
      setOpenUpdateColumn(true)
      setColumnKey({
        key: key
        })
      }

    const handleClickUpdate = event => {
      // console.log([...selected.data.data][columnKey.key])

      selected.data.data[columnKey.key].title = values.title
      // console.log([...selected.data.data])

      updateChart(projectId, chartId, {...selected, data: {
        data: selected.data.data,
        series: selected.data.series
        }})
      setOpenUpdateColumn(false)
    }

    const columnClickDelete = key => {
      // {// console.log(key)}
      const newData = [...selected.data.data]

      newData.splice(key,1)
      // {// console.log(newData)}


      updateChart(projectId, chartId, {...selected, data: {
        data: newData,
        series: selected.data.series
        }})
      setOpenUpdateColumn(false)

      setColumnKey({
        key: 0
      })

      window.location.reload(false);

    }

    const clickRowUpdate = key => {
      setOpenUpdateRow(true)
      setRowKey({
        key: key
        })
    }

    const handleClickUpdateRow = key => {
      // console.log('handleClickUpdateRow')
      selected.data.data.forEach((item) => {
        item[values.title] = item[selected.data.series[rowKey.key]]
        delete item[selected.data.series[rowKey.key]]
      });
      // console.log(selected.data.data)
      selected.data.series[rowKey.key] = values.title

      updateChart(projectId, chartId, {...selected, data: {
        data: selected.data.data,
        series: selected.data.series
        }})
      setOpenUpdateRow(false)
      window.location.reload(false);
    }

    const rowClickDelete = key => {
      // {// console.log(key)}
      const newData = [...selected.data.series]

      newData.splice(key,1)
      // {// console.log(newData)}

      window.location.reload(false);
      updateChart(projectId, chartId, {...selected, data: {
        data: selected.data.data,
        series: newData
        }})
      setOpenUpdateRow(false)
      setRowKey({
        key: 0
      })
    }

    const onDragEnd = result => {
      const { source, destination } = result;
      // console.log('onDragEnd', result)

      if (destination != null) {
        const newData = reorder(
                  selected.data.data,
                  source.index,
                  destination.index,
                  destination.droppableId
              );
              // // console.log('items',newData)
              // setValues({data: newData});
              updateChart(projectId, chartId, {...selected, data: {
                data: newData,
                series: selected.data.series
              }})
      }
      window.location.reload(false);
    }

    const chooseImport = (key) => {
      updateChart(projectId, chartId, {...selected, data: strategyMapList[key].data, insights: strategyMapList[key].insights});
      setAnchorEl(false);
      setOpenImport(false);
      window.location.reload(false);
    }

    const handleClickMenu = event => {
      setAnchorEl(event.currentTarget);
    }

    const handleCloseMenu = event => {
      setAnchorEl(false);
    }


    const color = [
      '#ec407a',
      '#7e57c2',
      '#4caf50',
      '#ffeb3b',
      '#03a9f4',
      '#1c7ff4',
    ]

    return (

      <>

      <div
        className={classes.head}>
        <ChangeChartTitle
          selected={selected}
          projectId={projectId}
          chartId={chartId}
          title={<h1
            className={classes.h1}>To-Be Strategy Canvas | {selected.title} </h1>}/>
        <EdModal
          TextRu={ToBeStrategyMapEd}
          TextEng={ToBeStrategyMapEdEnglish}/>
      </div>

      <Button
        className={classes.ButtonImport}
        variant="contained"
        color="primary"
        style={{
          background: 'linear-gradient(45deg, #1c7ff4 30%, #45adf7'}}
        onClick={() => setOpenImport(true)}
      >
          import Keys
      </Button>
        <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            className={classes.modal}
            open={openImport}
            onClose={() => setOpenImport(false)}
        >
              <div className={classes.paper}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleClickMenu}
                    style={{
                      background: 'linear-gradient(45deg, #1c7ff4 30%, #45adf7'}}
                    className={classes.Button}
                    >
                    CHOOSE AS-IS Strategy Canvas
                  </Button>
                  <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={() => handleCloseMenu()}
                  >
                    {Object.values(strategyMapList).map((item, index) => (
                      <div
                        key={(toString(index)+'modalnew')}>
                        <MenuItem
                          key={(toString(index)+'modalnew')}
                          onClick={() => chooseImport(index)}>
                            {item.title}
                        </MenuItem>
                      </div>
                    ))}


                  </Menu>
              </div>
        </Modal>

        <ToBeCharts
          color={color}
          data={selected.data.data}
          series={selected.data.series}
          save={({data, series}) => updateChart(projectId, chartId, {data: {data, series}})}/>

        {selected.data.data && <>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable
            droppableId="droppable"
            direction="horizontal">
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                  {...provided.droppableProps}
                >
                          {Object.values(selected.data.data).map(
                            (obj, key) => (
                              <Draggable
                                  key={obj.title}
                                  draggableId={obj.title}
                                  index={key}
                              >
                                  {(provided, snapshot) => (
                                      <div
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={getItemStyle(
                                                snapshot.isDragging,
                                                provided.draggableProps.style
                                          )}
                                          key={obj.title}
                                      >
                                            <div className={classes.ButtonContener}
                                              key={obj.title}>
                                                  <div
                                                    key={key}
                                                    className={classes.buttonColumn}
                                                    onClick={()=>clickColumnUpdate(key)}>
                                                            {obj.title}

                                                  </div>
                                            </div>
                                      </div>
                                  )}
                            </Draggable>
                        ))}

                    {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </>
      }

      {selected.data.series && <>
        <div
          className={classes.b}>
            {Object.values(selected.data.series).map(
              (obj, key) =>
              <div
                className={classes.Button}>
                  <div
                    key={key}
                    className={classes.b}
                    style={{
                      position: 'absolute',
                      top: `${(-key*15)*(414/100)+540}px`,
                      left: '1220px'
                    }}>
                        <Button
                          variant="contained"
                          className={classes.seriesButton}
                          onClick={()=>clickRowUpdate(key)}
                          style={{
                            backgroundColor: colorButton[key]
                          }}>
                          {obj}
                        </Button>
                  </div>
              </div>
            )}
        </div>
      </>
      }

        <div>
          <ButtonDeleteChart
            projectId={projectId}
            chartId={chartId}/>
        </div>
        <Insights
          selected={selected}
          projectId={projectId}
          chartId={chartId}/>

          <Modal
              aria-labelledby="simple-modal-title2"
              aria-describedby="simple-modal-description2"
              className={classes.modal}
              open={openUpdateColumn}
              onClose={() => setOpenUpdateColumn(false)}
          >
              <div className={classes.paper}>
                {selected.data.data && <>
                  <h2 id="simple-modal-title2">Change name {selected.data.data[columnKey.key].title}</h2>
                    <form
                        className={classes.form}
                        noValidate autoComplete="off">
                        <TextField
                            id="title"
                            label="factor"
                            defaultValue={selected.data.data[columnKey.key].title}
                            onChange={handleChange('title')}/>
                    </form>
                    <br/>
                    <div
                      className={classes.deleteRow}>
                      <Button
                          variant="contained"
                          color="primary"
                          disabled={values.title.length === 0 ? true : false}
                          style={{
                            background: 'linear-gradient(45deg, #1c7ff4 30%, #45adf7'}}
                          onClick={() => handleClickUpdate()}>
                          Update
                      </Button>
                      <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => columnClickDelete(columnKey.key)}>
                          Delete
                      </Button>
                    </div>
                  </>
                }
              </div>
          </Modal>

          <Modal
              aria-labelledby="simple-modal-title2"
              aria-describedby="simple-modal-description2"
              className={classes.modal}
              open={openUpdateRow}
              onClose={() => setOpenUpdateRow(false)}
          >
              <div className={classes.paper}>
                {selected.data.series && <>
                  <h2 id="simple-modal-title2">Change company name</h2>
                    <form
                        className={classes.form}
                        noValidate autoComplete="off">
                        <TextField
                            id="title"
                            label="company"
                            defaultValue={selected.data.series[rowKey.key]}
                            onChange={handleChange('title')}/>
                    </form>
                    <br/>
                    <div
                      className={classes.deleteRow}>
                      <Button
                          variant="contained"
                          color="primary"
                          disabled={values.title.length === 0 ? true : false}
                          style={{
                            background: 'linear-gradient(45deg, #1c7ff4 30%, #45adf7'}}
                          onClick={() => handleClickUpdateRow()}>
                          Update
                      </Button>
                      <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => rowClickDelete(rowKey.key)}>
                          Delete
                      </Button>
                    </div>
                  </>
                }
              </div>
          </Modal>
      </>
    )
}


const mapStateToProps = state => ({...state.charts, strategyMapList: state.strategyMap.data});
const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

export default connect(
    mapStateToProps, mapDispatchToProps,
)(ToBeStrategyMapDetail)
